/**
 * «Volver»: el botón de atrás de la aplicación.
 *
 * ANTES DECÍA EL NOMBRE DEL LUGAR —«← RetoCR»— y eso obliga a leerlo para
 * saber qué hace. «Volver» se entiende sin leer, que es justamente lo que
 * uno quiere del control que más se usa.
 *
 * VUELVE POR DONDE SE VINO, de verdad: si alguien llegó a un torneo desde la
 * pestaña de Torneos, volver al club sería mandarlo a un lugar donde no
 * estaba. Eso es lo que hace `navigate(-1)`.
 *
 * PERO NO SIEMPRE HAY UN «ATRÁS». Con un enlace compartido por WhatsApp, el
 * torneo es la PRIMERA pantalla de la sesión: ahí `navigate(-1)` saca a la
 * persona de la aplicación —al chat, o a una pestaña en blanco—. Por eso
 * `to`, que es el lugar de siempre: el club al que pertenece lo que se está
 * mirando. React Router marca la primera entrada del historial con la clave
 * `'default'`, y esa es la señal de que no hay a dónde volver.
 *
 * ES UN `<button>` Y NO UN ENLACE, a diferencia de casi todo lo demás: lo que
 * hace no es «ir a esta dirección» sino «deshacer el último paso», y de un
 * enlace uno espera poder copiar el destino o abrirlo en otra pestaña. Acá no
 * hay un destino fijo que copiar.
 */
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

export function BackButton({ to }: { to: string }): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { key } = useLocation();

  return (
    <p className="links">
      <button
        type="button"
        className="secondary back-button"
        onClick={() => {
          if (key === 'default') navigate(to, { replace: true });
          else navigate(-1);
        }}
      >
        <span aria-hidden="true">←</span> {t('common.back')}
      </button>
    </p>
  );
}
